<template>
    <div>
        <v-card height="340px">
            <v-toolbar outlined flat style="height: 60px">
                <v-toolbar-title>
                    <v-subheader class="text-caption text-uppercase font-weight-bold primary--text pl-0">{{graph.name}}</v-subheader>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <div v-if="graph.props[0]==='kwht'">
                    <v-btn text x-small v-model="kwh.btn0" :color="kwh.btn0 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[0])"> {{ items[0] }} </v-btn>
                    <v-btn text x-small v-model="kwh.btn1" :color="kwh.btn1 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[1])"> {{ items[1] }} </v-btn>
                    <v-btn text x-small v-model="kwh.btn2" :color="kwh.btn2 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[2])"> {{ items[2] }} </v-btn>
                    <v-btn text x-small v-model="kwh.btn3" :color="kwh.btn3 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[3])"> {{ items[3] }} </v-btn>
                </div>
                <div v-if="graph.props[0]==='watts'">
                    <v-btn text x-small v-model="w.btn0" :color="w.btn0 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[0])"> {{ items[0] }} </v-btn>
                    <v-btn text x-small v-model="w.btn1" :color="w.btn1 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[1])"> {{ items[1] }} </v-btn>
                    <v-btn text x-small v-model="w.btn2" :color="w.btn2 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[2])"> {{ items[2] }} </v-btn>
                </div>
                <div v-if="graph.props[0]==='volts'">
                    <v-btn text x-small v-model="v.btn0" :color="v.btn0 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[0])"> {{ items[0] }} </v-btn>
                    <v-btn text x-small v-model="v.btn1" :color="v.btn1 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[1])"> {{ items[1] }} </v-btn>
                    <v-btn text x-small v-model="v.btn2" :color="v.btn2 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[2])"> {{ items[2] }} </v-btn>
                </div>
                <div v-if="graph.props[0]==='amps'">
                    <v-btn text x-small v-model="a.btn0" :color="a.btn0 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[0])"> {{ items[0] }} </v-btn>
                    <v-btn text x-small v-model="a.btn1" :color="a.btn1 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[1])"> {{ items[1] }} </v-btn>
                    <v-btn text x-small v-model="a.btn2" :color="a.btn2 ? 'accent' : 'grey darken-3'" @click="setGraphData(graph.props[0], items[2])"> {{ items[2] }} </v-btn>
                </div>
                <v-btn text small @click="refresh"> <v-icon>mdi-refresh</v-icon> </v-btn>
            </v-toolbar>
                <v-card-text>
                    <chart_ v-if="graph.graph == CHART" :data="data" :type="graph.type" :historic="historic != undefined"  height="80%"/>
                    <widget_ v-if="graph.graph == WIDGET" :data="data" :graph="graph"/>
                </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { KWH, COLUMS } from './props-types'
import { mapActions, mapGetters, mapState } from "vuex";
import { CHART, WIDGET } from './props-types'
import { Readings } from '../../api'
import chart_ from './Chart'
import widget_ from './Widget'
import { max } from 'moment';
export default {
    name: "GraphsGroup",
    components: { chart_, widget_ },
    props: ['meter', 'graph', 'historic','width'],
    computed: {
        ...mapState({
            arrayOUT: state => state.meters.arrayOUT,
        })
    },
    data() {
        return {
            arrayDevices: [],
            data: {},
            dataAll: {},
            data15: {},
            data7: {},
            datacurr: {},
            items: [],
            vData: { vm60: {}, vh12: {}, vAll: {} },
            aData: { am60: {}, ah12: {}, aAll: {} },
            wData: { wm60: {}, wh12: {}, wAll: {} },
            kwh: { btn0: true, btn1: false, btn2: false, btn3: false},
            w: { btn0: false, btn1: false, btn2: true},
            v: { btn0: false, btn1: false, btn2: true},
            a: { btn0: false, btn1: false, btn2: true},
            dayRecords: {},
            halfDayRecords: {},
            lastHourRecords: {},
            CHART, WIDGET, KWH, COLUMS
        };
    },
    methods: {
        ...mapActions({ updateMeterDayData: "meters/updateMeterData", getHistoricData: 'meters/getHistoricData' }),
        async refresh() {
            await this.filterDevices()
            await this.watchReadings()
            if(this.graph.name === 'KWH month') this.items = ['Current Month', '7 days', '15 days', '30 days']
            else this.items = ['Last hour', '12 hours', '24 hours']
            if(this.historic != undefined) return this.formatChartHistoric()
            if(this.graph.graph == CHART) return this.formatChartData()
            // return this.formatChartData()
            if(this.graph.graph == WIDGET) return this.formatWidgetData()
            
        },
        formatWidgetData(){
            this.data = this.dataMeter[this.dataMeter.length - 1]
        },
        async formatChartHistoric(){
            this.graph.setType(this.COLUMS)
            let data = []; let m; let dims = []; let maxVal = 0
            for (let index = 0; index < this.arrayDevices.length; index++) { const mtr = this.arrayDevices[index]; m = await this.getHistoricData({ id_meter: mtr.name });  dims.push(m.data.length); data.push(m) }
            maxVal = Math.max(...dims)

            let currDate = new Date(); let currMonth = currDate.getMonth()+1 ; let prevArray = []; let follArray = []; let subPrev; let subFoll; let dimsPrev = []

            for (let idx1 = 0; idx1 < data.length; idx1++) {
                subPrev = []; subFoll = []
                for (let idx2 = 0; idx2 < maxVal; idx2++) {
                    if(data[idx1].data[idx2] != undefined) {
                        if (data[idx1].data[idx2]._id.month === currMonth) subFoll.push(data[idx1].data[idx2])
                        else subPrev.push(data[idx1].data[idx2])
                    }
                }
                prevArray.push(subPrev)
                dimsPrev.push(subPrev.length)
                follArray.push(subFoll)                
            }
            
            let follIdx = Math.max(...dimsPrev); let c1 = 0; let c2 = 0

            for (let idx1 = 0; idx1 < prevArray.length; idx1++) {
                c1 = 0
                for (let i = 0; i < prevArray[idx1].length-1; i++) {
                    c1 += 1
                    if (prevArray[idx1][i]._id.day > prevArray[idx1][i + 1]._id.day) {
                        for (let j = c1; j >= 1; j--) {
                            if (prevArray[idx1][j]._id.day < prevArray[idx1][j-1]._id.day) {
                                let num = prevArray[idx1][j];
                                prevArray[idx1][j] = prevArray[idx1][j - 1];
                                prevArray[idx1][j - 1] = num;
                            }
                        }
                    }
                }
            }

            for (let idx1 = 0; idx1 < follArray.length; idx1++) {
                c2 = 0
                for (let i = 0; i < follArray[idx1].length-1; i++) {
                    c2 += 1
                    if (follArray[idx1][i]._id.day > follArray[idx1][i + 1]._id.day) {
                        for (let j = c2; j >= 1; j--) {
                            if (follArray[idx1][j]._id.day < follArray[idx1][j-1]._id.day) {
                                let num = follArray[idx1][j];
                                follArray[idx1][j] = follArray[idx1][j - 1];
                                follArray[idx1][j - 1] = num;
                            }
                        }
                    }
                }
            }

            let allDev = []; let newArray; let dArr = []; let dates = []
            
            for (let index = 0; index < dims.length; index++) { newArray = prevArray[index].concat(follArray[index]); allDev.push(newArray); dArr.push(newArray.length) }

            let maxLength = Math.max(...dArr)
            let maxIdx = dArr.findIndex(m => m === maxLength)

            for (let index = 0; index < maxLength; index++) {
                const element = allDev[maxIdx][index];
                let obj = { year: element._id.year, month: element._id.month, day: element._id.day }
                dates.push(obj)
            }

            let acc = []

            for (let idx1 = 0; idx1 < dates.length; idx1++) {
                let date = dates[idx1]
                let larr = []
                for (let idx2 = 0; idx2 < dArr.length; idx2++) {
                    let dev = allDev[idx2]
                    for (let idx3 = 0; idx3 < dev.length; idx3++) {
                        let obj = dev[idx3].lines
                        let testDate = dev[idx3]._id
                        if(date.year === testDate.year && date.month === testDate.month && date.day === testDate.day){ larr.push(obj); break }
                        else{ continue }
                    }
                }
                let dObj = { date: date, devices: larr}
                acc.push(dObj)
            }

            let acc7 = []; let acc15 = []; let accurr = []

            for (let index = acc.length - 7; index < acc.length; index++) acc7.push(acc[index]);
            for (let index = acc.length - 15; index < acc.length; index++) acc15.push(acc[index]);
            for (let index = follIdx; index < acc.length; index++) accurr.push(acc[index]);

            let gen24 = [];
            acc.forEach(elem1 => { 
                let reads = []
                let devs = elem1.devices
                devs.forEach(elem2 => { let read = elem2[0].kwht;  reads.push(read) });
                let d = elem1.date
                let sum = reads.reduce((s, a) => s + a, 0)
                let obj = { date: d, read: sum }
                gen24.push(obj)
            });
            const data_formated = { categories: [], series: [{ line: '0', prop: KWH, data: [] }] }
            gen24.forEach(element => {
                let dt = new Date(element.date.year, element.date.month-1, element.date.day);
                data_formated.categories.push(dt.toLocaleDateString())
                data_formated.series.forEach( serie => { serie.data.push({ x: dt.getTime(), y: element.read }) })  
            });
            this.dataAll = data_formated

            let gen7 = [];
            acc7.forEach(elem1 => { 
                let reads = []
                let devs = elem1.devices
                devs.forEach(elem2 => { let read = elem2[0].kwht; reads.push(read) });
                let d = elem1.date
                let sum = reads.reduce((s, a) => s + a, 0)
                let obj = { date: d, read: sum }
                gen7.push(obj)
            });
            const data_7 = { categories: [], series: [{ line: '0', prop: KWH, data: [] }] }
            gen7.forEach(element => {
                let dt = new Date(element.date.year, element.date.month-1, element.date.day);
                data_7.categories.push(dt.toLocaleDateString())
                data_7.series.forEach( serie => { serie.data.push({ x: dt.getTime(), y: element.read }) })  
            });
            this.data7 = data_7

            let gen15 = [];
            acc15.forEach(elem1 => { 
                let reads = []
                let devs = elem1.devices
                devs.forEach(elem2 => { let read = elem2[0].kwht; reads.push(read) });
                let d = elem1.date
                let sum = reads.reduce((s, a) => s + a, 0)
                let obj = { date: d, read: sum }
                gen15.push(obj)
            });
            const data_15 = { categories: [], series: [{ line: '0', prop: KWH, data: [] }] }
            gen15.forEach(element => {
                let dt = new Date(element.date.year, element.date.month-1, element.date.day);
                data_15.categories.push(dt.toLocaleDateString())
                data_15.series.forEach( serie => { serie.data.push({ x: dt.getTime(), y: element.read }) })  
            });
            this.data15 = data_15

            let gencurr = [];
            accurr.forEach(elem1 => { 
                let reads = []
                let devs = elem1.devices
                devs.forEach(elem2 => {
                    let read = elem2[0].kwht
                    reads.push(read)
                });
                let d = elem1.date
                let sum = reads.reduce((s, a) => s + a, 0)
                let obj = { date: d, read: sum }
                gencurr.push(obj)
            });
            const data_curr = { categories: [], series: [{ line: '0', prop: KWH, data: [] }] }
            gencurr.forEach(element => {
                let dt = new Date(element.date.year, element.date.month-1, element.date.day);
                data_curr.categories.push(dt.toLocaleDateString())
                data_curr.series.forEach( serie => { serie.data.push({ x: dt.getTime(), y: element.read }) })  
            });
            this.datacurr = data_curr
            this.data = this.datacurr
            
        },
        async formatChartData() {
            try {
                let lines = [0,1,2]
                let prop = this.graph.props
                
                let dims24 = []
                for (let index = 0; index < this.dayRecords.length; index++) {
                    const element = this.dayRecords[index].data.length;
                    dims24.push(element)
                }
                let maxVal24 = Math.max(...dims24)
                let maxIdx24 = dims24.findIndex(n => n === maxVal24)

                let hrs24 = []
                for (let index = 0; index < maxVal24; index++) {
                    const element = this.dayRecords[maxIdx24].data[index];
                    hrs24.push(element.timestamp)
                }

                let acc24h = []
                for (let idx1 = 0; idx1 < hrs24.length; idx1++) {
                    const elem1 = hrs24[idx1];
                    let larr = []
                    for (let idx2 = 0; idx2 < this.dayRecords.length; idx2++) {
                        const elem2 = this.dayRecords[idx2];
                        for (let idx3 = 0; idx3 < elem2.data.length; idx3++) {
                            if (elem1 === elem2.data[idx3].timestamp) { larr.push(elem2.data[idx3].lines); break } 
                            else { continue }
                        }
                    }
                    let dObj = { hour: elem1, devices: larr}
                    acc24h.push(dObj)
                }

                let gen24 = []
                acc24h.forEach(element => {
                    let h = element.hour
                    let l1 = []; let l2 = []; let l3 = []
                    element.devices.forEach(device => {
                        device.forEach(line => {
                            switch (line.nline) {
                                case 1: {
                                    if (prop[0] === 'volts') l1.push(line[prop]/element.devices.length)
                                    else l1.push(line[prop])
                                    break;
                                }
                                case 2: {
                                    if (prop[0] === 'volts') l2.push(line[prop]/element.devices.length)
                                    else l2.push(line[prop])
                                    break;
                                }                            
                                default: {
                                    if (prop[0] === 'volts') l3.push(line[prop]/element.devices.length)
                                    else l3.push(line[prop])
                                    break;
                                }
                            }
                        });
                    });
                    let sum1 = Number(l1.reduce((s, a) => s + a, 0).toFixed(2))
                    let sum2 = Number(l2.reduce((s, a) => s + a, 0).toFixed(2))
                    let sum3 = Number(l3.reduce((s, a) => s + a, 0).toFixed(2))
                    let obj = { hour: h, l1: sum1, l2: sum2, l3: sum3}
                    gen24.push(obj)
                });

                const data_formated = { categories: [], series: [] }
                lines.forEach(line => { data_formated.series.push({ line: String(line), prop: prop[0], data: [] }) });
                gen24.forEach(element => {
                    let actual_time = new Date(element.hour)
                    let l1 = element.l1; let l2 = element.l2; let l3 = element.l3
                    if(prop[0] === 'watts'){ l1 = (l1/1000).toFixed(2); l2 = (l2/1000).toFixed(2); l3 = (l3/1000).toFixed(2) }
                    data_formated.categories.push(actual_time.toLocaleTimeString().slice(0, -3))
                    data_formated.series[0].data.push({ x: actual_time.getTime(), y: l1 })
                    data_formated.series[1].data.push({ x: actual_time.getTime(), y: l2 })
                    data_formated.series[2].data.push({ x: actual_time.getTime(), y: l3 })
                });
                this.data = data_formated
                if (this.data.series[0].prop === 'watts') { this.wData.wAll = this.data }
                else if (this.data.series[0].prop === 'volts') { this.vData.vAll = this.data }
                else { this.aData.aAll = this.data } 
                

                let dims12 = []
                for (let index = 0; index < this.halfDayRecords.length; index++) {
                    const element = this.halfDayRecords[index].data.length;
                    dims12.push(element)
                }
                let maxVal12 = Math.max(...dims12)
                let maxIdx12 = dims12.findIndex(n => n === maxVal12)

                let hrs12 = []
                for (let index = 0; index < maxVal12; index++) {
                    const element = this.halfDayRecords[maxIdx12].data[index];
                    hrs12.push(element.timestamp)
                }

                let acc12h = []
                for (let idx1 = 0; idx1 < hrs12.length; idx1++) {
                    const elem1 = hrs12[idx1];
                    let larr = []
                    for (let idx2 = 0; idx2 < this.halfDayRecords.length; idx2++) {
                        const elem2 = this.halfDayRecords[idx2];
                        for (let idx3 = 0; idx3 < elem2.data.length; idx3++) {
                            if (elem1 === elem2.data[idx3].timestamp) { larr.push(elem2.data[idx3].lines); break } 
                            else { continue }
                        }
                    }
                    let dObj = { hour: elem1, devices: larr}
                    acc12h.push(dObj)
                }

                let gen12 = []//Obtain sum of records per hour
                acc12h.forEach(element => {
                    let h = element.hour
                    let l1 = []; let l2 = []; let l3 = []
                    element.devices.forEach(device => {
                        device.forEach(line => {
                            switch (line.nline) {
                                // case 1: l1.push(line[prop]); break;
                                // case 2: l2.push(line[prop]); break;                            
                                // default: l3.push(line[prop]); break;
                                case 1: {
                                    if (prop[0] === 'volts') l1.push(line[prop]/element.devices.length)
                                    else l1.push(line[prop])
                                    break;
                                }
                                case 2: {
                                    if (prop[0] === 'volts') l2.push(line[prop]/element.devices.length)
                                    else l2.push(line[prop])
                                    break;
                                }                            
                                default: {
                                    if (prop[0] === 'volts') l3.push(line[prop]/element.devices.length)
                                    else l3.push(line[prop])
                                    break;
                                }
                            }
                        });
                    });
                    let sum1 = Number(l1.reduce((s, a) => s + a, 0).toFixed(2))
                    let sum2 = Number(l2.reduce((s, a) => s + a, 0).toFixed(2))
                    let sum3 = Number(l3.reduce((s, a) => s + a, 0).toFixed(2))
                    let obj = { hour: h, l1: sum1, l2: sum2, l3: sum3}
                    gen12.push(obj)
                });

                const data_h12 = { categories: [], series: [] }
                lines.forEach(line => { data_h12.series.push({ line: String(line), prop: prop[0], data: [] }) });
                gen12.forEach(element => {
                    let actual_time = new Date(element.hour)
                    let l1 = element.l1; let l2 = element.l2; let l3 = element.l3
                    if(prop[0] === 'watts'){ l1 = (l1/1000).toFixed(2); l2 = (l2/1000).toFixed(2); l3 = (l3/1000).toFixed(2) }
                    data_h12.categories.push(actual_time.toLocaleTimeString().slice(0, -3))
                    data_h12.series[0].data.push({ x: actual_time.getTime(), y: l1 })
                    data_h12.series[1].data.push({ x: actual_time.getTime(), y: l2 })
                    data_h12.series[2].data.push({ x: actual_time.getTime(), y: l3 })
                });
                if (this.data.series[0].prop === 'watts') { this.wData.wh12 = data_h12 }
                else if (this.data.series[0].prop === 'volts') { this.vData.vh12 = data_h12 }
                else { this.aData.ah12 = data_h12 }   

                /*1 hour*/
                let dims60 = []
                for (let index = 0; index < this.lastHourRecords.length; index++) {
                    const element = this.lastHourRecords[index].data.length;
                    dims60.push(element)
                }
                let maxVal60 = Math.max(...dims60)
                let maxIdx60 = dims60.findIndex(n => n === maxVal60)

                let mins60 = []//Obtain array of hours
                for (let index = 0; index < maxVal60; index++) {
                    const element = this.lastHourRecords[maxIdx60].data[index];
                    mins60.push(element.timestamp)
                }

                let acc60m = []
                for (let idx1 = 0; idx1 < mins60.length; idx1++) {
                    const elem1 = mins60[idx1];
                    let larr = []
                    for (let idx2 = 0; idx2 < this.lastHourRecords.length; idx2++) {
                        const elem2 = this.lastHourRecords[idx2];
                        for (let idx3 = 0; idx3 < elem2.data.length; idx3++) {
                            if (elem1 === elem2.data[idx3].timestamp) { larr.push(elem2.data[idx3].lines); break } 
                            else { continue }
                        }
                    }
                    let dObj = { hour: elem1, devices: larr}
                    acc60m.push(dObj)
                }

                let gen60 = []
                acc60m.forEach(element => {
                    let h = element.hour
                    let l1 = []; let l2 = []; let l3 = []
                    element.devices.forEach(device => {
                        device.forEach(line => {
                            switch (line.nline) {
                                // case 1: l1.push(line[prop]); break;
                                // case 2: l2.push(line[prop]); break;                            
                                // default: l3.push(line[prop]); break;
                                case 1: {
                                    if (prop[0] === 'volts') l1.push(line[prop]/element.devices.length)
                                    else l1.push(line[prop])
                                    break;
                                }
                                case 2: {
                                    if (prop[0] === 'volts') l2.push(line[prop]/element.devices.length)
                                    else l2.push(line[prop])
                                    break;
                                }                            
                                default: {
                                    if (prop[0] === 'volts') l3.push(line[prop]/element.devices.length)
                                    else l3.push(line[prop])
                                    break;
                                }
                            }
                        });
                    });
                    let sum1 = Number(l1.reduce((s, a) => s + a, 0).toFixed(2))
                    let sum2 = Number(l2.reduce((s, a) => s + a, 0).toFixed(2))
                    let sum3 = Number(l3.reduce((s, a) => s + a, 0).toFixed(2))
                    let obj = { hour: h, l1: sum1, l2: sum2, l3: sum3}
                    gen60.push(obj)
                });

                const data_m60 = { categories: [], series: [] }
                lines.forEach(line => { data_m60.series.push({ line: String(line), prop: prop[0], data: [] }) });
                gen60.forEach(element => {
                    let actual_time = new Date(element.hour)
                    let l1 = element.l1; let l2 = element.l2; let l3 = element.l3
                    if(prop[0] === 'watts'){ l1 = (l1/1000).toFixed(2); l2 = (l2/1000).toFixed(2); l3 = (l3/1000).toFixed(2) }
                    data_m60.categories.push(actual_time.toLocaleTimeString().slice(0, -3))
                    data_m60.series[0].data.push({ x: actual_time.getTime(), y: l1 })
                    data_m60.series[1].data.push({ x: actual_time.getTime(), y: l2 })
                    data_m60.series[2].data.push({ x: actual_time.getTime(), y: l3 })
                });
                if (this.data.series[0].prop === 'watts') { this.wData.wm60 = data_m60 }
                else if (this.data.series[0].prop === 'volts') { this.vData.vm60 = data_m60 }
                else { this.aData.am60 = data_m60 }

            } catch (error) {
                console.log(error)
            }
        },
        setGraphData(prop, item){
            if (prop === 'kwht') {
                switch (item) {
                    case '7 days': { this.data = this.data7; this.kwh.btn0 = false; this.kwh.btn1 = true; this.kwh.btn2 = false; this.kwh.btn3 = false; break; }
                    case '15 days': { this.data = this.data15; this.kwh.btn0 = false; this.kwh.btn1 = false; this.kwh.btn2 = true; this.kwh.btn3 = false; break; }
                    case 'Current Month': { this.data = this.datacurr; this.kwh.btn0 = true; this.kwh.btn1 = false; this.kwh.btn2 = false; this.kwh.btn3 = false; break; }
                    default: { this.data = this.dataAll; this.kwh.btn0 = false; this.kwh.btn1 = false; this.kwh.btn2 = false; this.kwh.btn3 = true; break; }
                }
            } else if (prop === 'watts') {
                switch (item) { 
                    case 'Last hour': { this.data = this.wData.wm60; this.w.btn0 = true; this.w.btn1 = false; this.w.btn2 = false; break; }
                    case '12 hours': { this.data = this.wData.wh12; this.w.btn0 = false; this.w.btn1 = true; this.w.btn2 = false; break; }
                    default: { this.data = this.wData.wAll; this.w.btn0 = false; this.w.btn1 = false; this.w.btn2 = true; break; }
                }
            } else if (prop === 'volts') {
                switch (item) {
                    case 'Last hour': { this.data = this.vData.vm60; this.v.btn0 = true; this.v.btn1 = false; this.v.btn2 = false; break; }
                    case '12 hours': { this.data = this.vData.vh12; this.v.btn0 = false; this.v.btn1 = true; this.v.btn2 = false; break; }
                    default: { this.data = this.vData.vAll; this.v.btn0 = false; this.v.btn1 = false; this.v.btn2 = true; break; }
                }
            } else {
                switch (item) {
                    case 'Last hour': { this.data = this.aData.am60; this.a.btn0 = true; this.a.btn1 = false; this.a.btn2 = false; break; }
                    case '12 hours': { this.data = this.aData.ah12; this.a.btn0 = false; this.a.btn1 = true; this.a.btn2 = false; break; }
                    default: { this.data = this.aData.aAll; this.a.btn0 = false; this.a.btn1 = false; this.a.btn2 = true; break; }
                }
            }
        },
        filterDevices(){
            let groupMeters = this.meter; let i = 0; let nums = []; let devInit = []
            for (let index = 0; index < groupMeters.length; index++) { const element = groupMeters[index]; devInit.push(element) }
            for (let index = 0; index < this.arrayOUT.length; index++) {
                const e1 = this.arrayOUT[index].name;
                for (let index = 0; index < groupMeters.length; index++) {
                    i = this.meter.findIndex(m => m.name === e1)
                    if (i === -1) continue
                    else { nums.push(i); break }
                }
            }
            if(nums.length === 1) devInit.splice(nums[0], 1);
            else for (let index = nums.length - 1; index >= 0; index--) { devInit.splice(nums[index], 1) }
            this.arrayDevices = devInit
        },
        async watchReadings(){
            let dayR = []; let hdayR = []; let lHourR = []; let m
            for (let index = 0; index < this.arrayDevices.length; index++) {
                const mtr = this.arrayDevices[index];
                m = await Readings.byMeter( { id: mtr.name, key: mtr.key }, { end: new Date().getTime(), start: new Date().getTime() - 1000 * 60 * 60 * 24 } ); dayR.push(m)
                m = await Readings.byMeter( { id: mtr.name, key: mtr.key }, { end: new Date().getTime(), start: new Date().getTime() - 1000 * 60 * 60 * 12 } ); hdayR.push(m)
                m = await Readings.byMeter( { id: mtr.name, key: mtr.key }, { end: new Date().getTime(), start: new Date().getTime() - 1000 * 60 * 60 * 1 } ); lHourR.push(m)
            }

            let ndayR = []
            for (let index = 0; index < dayR.length; index++) {
                const element = dayR[index];
                if(element.data.length <= 1440){ ndayR.push(element); continue }
                else{
                    let n = []; let indexes = []
                    for (let index = 0; index < element.data.length - 1; index++) { if (element.data[index] != undefined) { if (element.data[index].timestamp === element.data[index + 1].timestamp) { indexes.push(index + 1) } } }
                    for (let index = 0; index < indexes.length; index++) { const elem = indexes[index]; element.data.splice(elem, 1) }
                    ndayR.push(element)
                }
            }
            this.dayRecords = ndayR

            let nhdayR = []
            for (let index = 0; index < hdayR.length; index++) {
                const element = hdayR[index];
                if(element.data.length <= 720){
                    nhdayR.push(element); 
                    continue
                }else{
                    let n = []; let indexes = []
                    for (let index = 0; index < element.data.length - 1; index++) { if (element.data[index] != undefined) { if (element.data[index].timestamp === element.data[index + 1].timestamp) { indexes.push(index + 1) } } }
                    for (let index = 0; index < indexes.length; index++) { const elem = indexes[index]; element.data.splice(elem, 1) }
                    nhdayR.push(element)
                }
            }
            this.halfDayRecords = nhdayR

            let nlHourR = []
            for (let index = 0; index < lHourR.length; index++) {
                const element = lHourR[index];
                if(element.data.length <= 60){
                    nlHourR.push(element); 
                    continue
                }else{
                    let n = []; let indexes = []
                    for (let index = 0; index < element.data.length - 1; index++) { if (element.data[index] != undefined) { if (element.data[index].timestamp === element.data[index + 1].timestamp) { indexes.push(index + 1) } } }
                    for (let index = 0; index < indexes.length; index++) { const elem = indexes[index]; element.data.splice(elem, 1) }
                    nlHourR.push(element)
                }
            }
            this.lastHourRecords = lHourR
        },
    },
    mounted() {
        this.refresh()
    },
};
</script>

<style scoped>
div.a {
  text-align: center;
}
.dropdown{
    height: 45px;
    position: relative;
    right: 5px
}
</style>
